// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-5uQ-E"};